<template>
  <section class="fc-introduce">
    <h4 class="fc-introduce__title">수강 대상</h4>
    <h6 class="fc-introduce__sub-title">이런 분들께 추천 드려요!</h6>
    <ul class="fc-introduce__cards">
      <li v-for="{ icon, title } in cards" :key="title" class="fc-introduce__card">
        <figure class="fc-introduce__icon">
          <img :src="icon" :alt="title" />
        </figure>
        <span class="fc-introduce__desc">{{ title }}</span>
      </li>
    </ul>
    <h4 class="fc-introduce__title">강의 수강을 위한 사전지식</h4>
    <p class="fc-introduce__sub-title">이 정도 준비가 되어있다면, 강의 들을 준비 끝!</p>
    <ul class="fc-introduce__wrapper">
      <li v-for="(desc, i) in descriptions" :key="i" class="fc-introduce__text" v-html="desc"></li>
    </ul>
    <h4 class="fc-introduce__title">학습 목표</h4>
    <p class="fc-introduce__sub-title">석사 졸업생도 놀랄, 수강 후 당신의 모습!</p>
    <ul class="fc-introduce__wrapper">
      <li v-for="(desc, i) in goals" :key="i" class="fc-introduce__text" v-html="desc"></li>
    </ul>
  </section>
</template>

<script>
import Introduce01 from '../../../../img/ab-test/introduce_01.png';
import Introduce02 from '../../../../img/ab-test/introduce_02.png';
import Introduce03 from '../../../../img/ab-test/introduce_03.png';
import Introduce04 from '../../../../img/ab-test/introduce_04.png';

export default {
  name: 'introduce-open-cv',
  data() {
    return {
      Introduce01,
      Introduce02,
      Introduce03,
      Introduce04,
      cards: [
        {
          icon: Introduce01,
          title: '수학적 이해를 가지고 알고리즘을 이해하고 컴퓨터 비전을 경험하고 싶어요!',
        },
        {
          icon: Introduce02,
          title: '겉핥기식 강의 말고 주요한 내용은 깊이있게 학습하여 응용력을 길러보고 싶어요!',
        },
        {
          icon: Introduce03,
          title: '효율적인 OpenCV 코딩 기법을 배워서 컴퓨터 비전에 딥러닝을 활용해보고 싶어요!',
        },
        {
          icon: Introduce04,
          title: '컴퓨터 비전 프로그래밍 경험은 물론, 내 디바이스 (ex.웹캠)에서 구현해보고 싶어요!',
        },
      ],
      descriptions: [
        '✔️   파이썬 기초 문법 (조건문, 반복문, 클래스 이해) 은 기본적으로 필요합니다.',
        '✔️   고등학교 수준의 수학적 이해가 있으면 좋지만, 주요하게 이해해야 하는 수학적 내용 (ex. 행렬)은 수업에서 다시 한 번 다룹니다.',
        '✔️   컴퓨터 공학을 전공한 분들이 보다 쉽게 이해할 수도 있지만, 전공자만 들을 수 있는 수업은 아닙니다.',
        '✔️   영상, 이미지 데이터를 처음 다루는 분들도 수강하실 수 있습니다.',
      ],
      goals: [
        '✔️   Python을 활용한 OpenCV 영상 처리 프로그래밍 가능!',
        '✔️   컴퓨터 비전에 필요한 고급 알고리즘 원리 이해',
        '✔️   OpenCV의 코어 이해 및 수십가지 실습으로 얻게 되는 응용력! 적절한 파라미터 설정 방법까지!',
        '✔️   컴퓨터비전에서의 딥러닝 활용력.',
      ],
    };
  },
};
</script>
